/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/DesignSystem/PatientComms/PatientCommsContactMethods/Loading"
  
}) {
  return (<React.Fragment
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 delay={0}
/>
{children}
</React.Fragment>)
}